/*
 * @Author: liujiang liujiang@shjinjia.com.cn
 * @Date: 2022-07-13 11:09:31
 * @LastEditors: liujiang liujiang@shjinjia.com.cn
 * @LastEditTime: 2022-10-26 11:14:33
 * @FilePath: \oak\src\store\modules\routerMap\views\warehouse.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 独立仓
const map = {
  consignmentAndStock: () => import('@/views/warehouse/ConsignmentAndStock'),
  applyList: () => import('@/views/warehouse/ApplyList'),
  undertakesBilling: () => import('@/views/warehouse/UndertakesBilling'),
  applyDetail: () => import('@/views/warehouse/ApplyDetail'),
  requisitionDetail: () => import('@/views/warehouse/RequisitionDetail'),
  notshelfproductList: () => import('@/views/warehouse/NotShelfProductList'),
  priceAnomalyList: () => import('@/views/warehouse/PriceAnomalyList'),
  customerIdentityList: () => import('@/views/warehouse/CustomerIdentityList'), // 客户身份信息
  contractManagement: () => import('@/views/warehouse/ContractManagement'), // 合同管理
  sellDetail: () => import('@/views/warehouse/SellDetail'),
  goodsNotSpecifiedPrice: () => import('@/views/warehouse/GoodsNotSpecifiedPrice'), // 未指定代发货结算价格商品
  independentWarehouseSettlementPrice: () => import('@/views/warehouse/IndependentWarehouseSettlementPrice'), // 独立仓结算价格设置
  undertakesDistributorManage: () => import('@/views/warehouse/UndertakesDistributorManage'), // 代发分销商管理
  accountDetail: () => import('@/views/warehouse/components/PendingReview'), //! 代发客户信息审核及代发账务跳转页面
  dFBillReconApplyOrderTableList: () => import('@/views/warehouse/DFBillReconApplyOrderTableList'), // 账单导入
  dFAdJustMentForm: () => import('@/views/warehouse/DFAdJustMentForm'), // 调整单详情页面
  taxApplicationForm: () => import('@/views/warehouse/TaxApplicationForm'), // 税费对账申请单一览-上传税费账单
  ncFreightReconApplicationOrdTableList: () => import('@/views/warehouse/NcFreightReconApplicationOrdTableList'), // 运费对账申请单
  ncReconAdjustmentOrderTableList: () => import('@/views/warehouse/NcReconAdjustmentOrderTableList'), // 运费调整单
  ncAgencyBalanceDiffTableList: () => import('@/views/warehouse/NCAgencyBalanceDiffTableList'), // 代发nc余额核对

  // TODO:税费对账列表
  bondedTaxBillReconApplyOrderList: () => import('@/views/warehouse/BondedTaxBillReconApplyOrder'), // 税费申请单
  bondedTaxBillReconAdjustOrderList: () => import('@/views/warehouse/BondedTaxBillReconAdjustOrder'), // 对账调整单
  bondedTaxBillReconOrder: () => import('@/views/warehouse/BondedTaxBillReconOrder'), // 税费对账单

  dFAdJustMentList: () => import('@/views/warehouse/DFAdJustMentList') // 账单导入

}

export default map
